import { ModuleWithProviders, NgModule } from '@angular/core';
import { DivisionWidgetsModule } from '@app/features/division/division-widgets.module';
import { UserAvatarComponent } from '@app/features/user/widgets/user-avatar/user-avatar.component';
import { UserListOverlayFilterComponent } from '@app/features/user/widgets/user-list-widget/user-list-overlay/user-list-overlay-filter/user-list-overlay-filter.component';
import { SharedModule } from '@app/shared/shared.module';
import { HierarchyWidgetsModule } from '../hierarchy/hierarchy-widgets.module';
import { UserDropdownComponent } from './widgets/user-dropdown/user-dropdown.component';
import { UserListOverlayComponent } from './widgets/user-list-widget/user-list-overlay/user-list-overlay.component';
import { UserListOverlayTableData } from './widgets/user-list-widget/user-list-overlay/user-list-overlay.component.table';
import { UserListWidgetComponent } from './widgets/user-list-widget/user-list-widget.component';
import { UserListWidgetTableData } from './widgets/user-list-widget/user-list-widget.component.table';
import { UserSelectionWidgetComponent } from './widgets/user-selection-widget/user-selection-widget.component';
import { UserSelectionWidgetTableData } from './widgets/user-selection-widget/user-selection-widget.component.table';

@NgModule({
  declarations: [
    UserDropdownComponent,
    UserListWidgetComponent,
    UserListOverlayComponent,
    UserListOverlayFilterComponent,
    UserSelectionWidgetComponent,
    UserAvatarComponent
  ],
  imports: [SharedModule, DivisionWidgetsModule, HierarchyWidgetsModule],
  exports: [
    UserDropdownComponent,
    UserListWidgetComponent,
    UserListOverlayComponent,
    UserSelectionWidgetComponent,
    UserAvatarComponent
  ],
  providers: [UserListWidgetTableData, UserListOverlayTableData, UserSelectionWidgetTableData]
})
export class UserWidgetsModule {
  static forChild(): ModuleWithProviders<UserWidgetsModule> {
    return {
      ngModule: UserWidgetsModule
    };
  }
}
